
import React, { useState, useEffect } from "react";
import MaterialTable from '@material-table/core';
import createPersistedState from 'use-persisted-state';
import { useHistory } from 'react-router-dom';
import { ExportCsv } from "@material-table/exporters";
import { Banner } from '../../template/Banner'

const usePageSizeState = createPersistedState('pageSize');

function Persons() {
  let history = useHistory();
  const [pageSize, setPageSize] = usePageSizeState(10);

  const [data, setData] = useState();

  useEffect(() => {
    function fetchPageData() {
      fetch("http://medpub-backend-dmpn.ext.ocp-prod-0.k8s.it.helsinki.fi/persons")
      .then(res => res.json())
      .then(result => setData(result))
      .catch(console.log);
    }
    fetchPageData();
  }, []);

  return (
    <div className="persons">

      <Banner />
      <div className="page-box-tab">            
        <button className="tablinks link-people active" onClick={() => { history.push('/persons') }}><img src="profile.png" alt="" />People</button>
        <button className="tablinks link-works" onClick={() => { history.push('/works') }}><img src="publishing.png" alt="" />Works</button>
        <button className="tablinks link-places" onClick={() => { history.push('/places') }}><img src="location.png" alt="" />Places</button>  
        <button className="tablinks link-simple-search inactive" onClick={() => { history.push('/search') }}><img src="search.png" alt="" />Simple search</button>
        <button className="tablinks link-adv-search inactive" onClick={() => { history.push('/search/advanced') }}><img src="advanced.png" alt="" />Advanced search</button>
      </div>

      <div className="registry-page-container">  
        <div class="page-header">
          <img src="register-people.png" alt="" />
          <h1>Persons</h1>
        </div>

        <div>
          <MaterialTable
            columns={[
              { title: "ID", field: "id" },
              { title: "Name", field: "person_name"},
              { title: "Number of stations", field: "occpers_num" },
              { title: "Number of publications", field: "publ_num" },
              { title: "Stations", field: "occupations" }
            ]}
            data={data}
            options={{
              columnsButton: true,
              pageSize: pageSize,
              exportAllData: true,
              exportMenu: [
                {
                  label: "Export CSV",
                  exportFunc: (cols, datas) => ExportCsv(cols, datas, "persons"),
                },
              ],
              headerStyle: {
                backgroundColor: '#1b437e',
                color: '#FFF'
              },
            }}
            title=""
            onRowsPerPageChange={newPageSize => {
              setPageSize(newPageSize);
            }}
            onRowClick={((evt, selectedRow) => {
              history.push('person/' + selectedRow.id)
            })}
          />
        </div>
      </div>
    </div>
  );
}

export default Persons;